/* Astrophilos theme — minimal progressive enhancement.
   Reveal-on-scroll, cart drawer + add-to-cart, product gallery, quantity,
   dismissible announcement. Native Shopify cart AJAX API. */
(function () {
  "use strict";

  /* ---------------------------- reveal on scroll ---------------------------- */
  var reveals = document.querySelectorAll(".reveal");
  if ("IntersectionObserver" in window && reveals.length) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add("is-in");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
    );
    reveals.forEach(function (el, i) {
      var d = el.getAttribute("data-delay");
      if (d) el.style.transitionDelay = d + "ms";
      io.observe(el);
    });
  } else {
    reveals.forEach(function (el) { el.classList.add("is-in"); });
  }

  /* ---------------------------- announcement close -------------------------- */
  var annc = document.querySelector("[data-announcement]");
  if (annc) {
    if (localStorage.getItem("astro-annc") === "1") annc.style.display = "none";
    var close = annc.querySelector("[data-annc-close]");
    if (close) close.addEventListener("click", function () {
      annc.style.display = "none";
      try { localStorage.setItem("astro-annc", "1"); } catch (e) {}
    });
  }

  /* ------------------------------- cart drawer ------------------------------ */
  var drawer = document.getElementById("CartDrawer");
  function openDrawer() { if (drawer) drawer.classList.add("is-open"); }
  function closeDrawer() { if (drawer) drawer.classList.remove("is-open"); }

  document.querySelectorAll("[data-cart-toggle]").forEach(function (b) {
    b.addEventListener("click", function (e) { e.preventDefault(); openDrawer(); });
  });
  document.querySelectorAll("[data-cart-close]").forEach(function (b) {
    b.addEventListener("click", closeDrawer);
  });

  function money(cents) {
    return new Intl.NumberFormat(document.documentElement.lang || "en", {
      style: "currency",
      currency: window.Shopify && Shopify.currency ? Shopify.currency.active : "USD",
    }).format(cents / 100);
  }

  function renderCart(cart) {
    document.querySelectorAll("[data-cart-count]").forEach(function (el) {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? "" : "none";
    });
    var body = drawer && drawer.querySelector("[data-cart-body]");
    if (!body) return;
    if (cart.item_count === 0) {
      body.innerHTML =
        '<div class="cartd__empty"><p class="text-muted">' +
        (window.themeStrings ? themeStrings.empty : "Your cart is empty") +
        "</p></div>";
    } else {
      var html = "";
      cart.items.forEach(function (it) {
        html +=
          '<div class="cartd__item">' +
          '<div style="flex:1"><a href="' + it.url + '" style="font-weight:500">' + it.product_title + "</a>" +
          (it.variant_title ? '<div class="text-muted" style="font-size:.8rem">' + it.variant_title + "</div>" : "") +
          '<div class="qty" style="margin-top:.5rem"><button data-line="' + it.key + '" data-delta="-1">&minus;</button><input value="' + it.quantity + '" readonly><button data-line="' + it.key + '" data-delta="1">+</button></div>' +
          "</div>" +
          '<div style="font-family:Space Grotesk;font-weight:600">' + money(it.final_line_price) + "</div>" +
          "</div>";
      });
      body.innerHTML = html;
    }
    var sub = drawer && drawer.querySelector("[data-cart-subtotal]");
    if (sub) sub.textContent = money(cart.total_price);
  }

  function fetchCart() {
    fetch("/cart.js", { headers: { "Content-Type": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(renderCart);
  }

  // Add to cart (product form)
  document.querySelectorAll("[data-product-form]").forEach(function (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.setAttribute("disabled", "disabled");
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: form.querySelector('[name="id"]').value,
          quantity: parseInt(form.querySelector('[name="quantity"]') ? form.querySelector('[name="quantity"]').value : 1, 10),
        }),
      })
        .then(function (r) { return r.json(); })
        .then(function () { fetchCart(); openDrawer(); })
        .finally(function () { if (btn) btn.removeAttribute("disabled"); });
    });
  });

  // Change line quantity from the drawer
  document.addEventListener("click", function (e) {
    var b = e.target.closest("[data-line]");
    if (!b) return;
    var line = b.getAttribute("data-line");
    var delta = parseInt(b.getAttribute("data-delta"), 10);
    var input = b.parentNode.querySelector("input");
    var qty = Math.max(0, parseInt(input.value, 10) + delta);
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: line, quantity: qty }),
    })
      .then(function (r) { return r.json(); })
      .then(renderCart);
  });

  /* ------------------------------ product qty ------------------------------ */
  document.querySelectorAll("[data-qty]").forEach(function (wrap) {
    var input = wrap.querySelector("input");
    wrap.querySelectorAll("button").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var d = parseInt(btn.getAttribute("data-delta"), 10);
        input.value = Math.max(1, parseInt(input.value, 10) + d);
      });
    });
  });

  /* ---------------------------- product gallery ---------------------------- */
  document.querySelectorAll("[data-gallery]").forEach(function (g) {
    var main = g.querySelector("[data-gallery-main]");
    g.querySelectorAll("[data-gallery-thumb]").forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        var id = thumb.getAttribute("data-media-id");
        main.querySelectorAll("[data-media]").forEach(function (m) {
          m.style.display = m.getAttribute("data-media-id") === id ? "" : "none";
        });
        g.querySelectorAll("[data-gallery-thumb]").forEach(function (t) {
          t.classList.toggle("is-active", t === thumb);
        });
      });
    });
  });

  // Update the count on load
  if (document.querySelector("[data-cart-count]")) fetchCart();
})();
